import { isCoughSession, Session } from '../../misc/api/apiTypes';
import { NoMailAddressMessage } from '../../misc/api/DeviceLinkApi/GenericMessages';
import { DevicesAction, SetUploadStatusAction, SetInteractionModalStepAction, ReceiveMailAddressAction } from '../DevicesNewReducer';
import { Study, WebPortalClient } from 'webportalclient';
import { WebPortalLegacyClientInternal } from '../../misc/api/WebPortalTokenClient';

declare const rootUrl: string;

export class FetchMailAddressAsyncAction {
    static async create(client: WebPortalClient, dispatch: React.Dispatch<DevicesAction>, parentSessionCandidates: Session[], selectedSessionIds: string[], currentStudy: Study) {

        let siteCountryId = null;
        for (const sessionId of selectedSessionIds) {
            const selectedSession = parentSessionCandidates.find(x => x.Id === sessionId);
            siteCountryId = selectedSession.Site.CountryId;

            if (isCoughSession(selectedSession) && selectedSession.StatusId === 'CSS_RECEIVING_DATA_MAILED') {
                dispatch(SetUploadStatusAction.create(`The session '${selectedSession.Name}' has already been set to mailed`));
                return dispatch(SetInteractionModalStepAction.create(5));
            }
        }

        const siteCountry = (await client.getStudyCountries(undefined, `countryCode eq '${siteCountryId}'`)).value[0];

        if (!siteCountry.localPostalAddress) {
            dispatch(SetUploadStatusAction.create(NoMailAddressMessage));
            return dispatch(SetInteractionModalStepAction.create(5));
        }

        dispatch(ReceiveMailAddressAction.create(siteCountry.localPostalAddress));
        return dispatch(SetInteractionModalStepAction.create(10));
    }

    static async fetchMailAddress(legacyClient: WebPortalLegacyClientInternal, sessionId: string) {
        return await legacyClient.studyMediaPostalAddress(sessionId);
    }
}
